// @flow
import type { GlobalState } from "../../lib/types";

export const getAmenities = (state: GlobalState) => {
  return (state.config && state.config.amenities) || [];
};
export const getStartingCost = (state: GlobalState) => {
  return state.config.startingCost;
};
export const getDetailedPricing = (state: GlobalState) => {
  return (state.config && state.config.prices) || [];
};
/**
 * Text used to customize pricing services included text above the amenity list.
 * @param state
 * @returns {string}
 */
export const getPricingServicesText = (state: GlobalState) => {
  return (state.config && state.config.pricingServicesText) || "Services included with monthly rent";
};
/**
 * Text used to customize pricing result type. Could be Monly Rate, Monthly Budle, Day Rate, etc.
 * @param state
 * @returns {string}
 */
export const getPricingType = (state: GlobalState) => {
  return (state.config && state.config.pricingType) || "Monthly Rent";
};
/**
 * Return chosen care type from `userData` object.
 * @param state
 * @returns {string}
 */
export const getChosenCareType = (state: GlobalState) => {
  return state.userData.care;
};
